import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ServiceWorkerWrapper from "./core/updateApp";
import "bootstrap/dist/css/bootstrap.rtl.css";
import "./assets/styles/base.scss";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <>
      <ServiceWorkerWrapper />
      <App />
    </>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
